import { render } from "./FeaturedContent.vue?vue&type=template&id=d40158d6"
import script from "./FeaturedContent.vue?vue&type=script&lang=js"
export * from "./FeaturedContent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__